export enum TagType {
  PRODUCT_CATALOG = "product_catalog_tags",
}
